const openDeleteProductModalReducer = (state = false, action) => {
    switch(action.type) {
        case 'CHANGE_DELETE_PRODUCT_MODAL_STATUS':
            state = !state;
            return state;
        default:
            return state;
    }
}

export default openDeleteProductModalReducer;